
import { getBoxValue } from './Const/functions';
const Style = ({ attributes, clientId }) => {
    const { alignment, frameBorder, frameBRadius, frameBoxShadow, iframeStyle } = attributes;
    const { width, height } = iframeStyle;

    return <style dangerouslySetInnerHTML={{
        __html: `
        .wp-block-scb-sound-cloud {
            text-align:${alignment};
        }
        #scbSoundCloud-${clientId} .mainWidget{
            width:${width};
            height:${height};
        }
		#scbSoundCloud-${clientId} iframe{
            border: ${getBoxValue(frameBorder)};
            border-radius: ${getBoxValue(frameBRadius)};
            box-shadow: ${frameBoxShadow?.styles ?? 'none'};
        }
        `.replace(/\s+/g, ' ')
    }} />
}
export default Style;